import{transformToPlaybackCase as r}from"./transformToPlaybackCase.js";var o=function(o,a){return void 0===a&&(a=0),r("TITLE",o,a)};export{o as transformToPlaybackTitleCase};
//# sourceMappingURL=transformToPlaybackTitleCase.js.map
